var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.public_data)?_c('MemberTabbedLogin',{staticClass:"mx-auto mt-8",attrs:{"company_id":_vm.public_data.company_id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }